// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import trailerApi from '~/apis/trailer';
import { IQueryParamTruck } from '~/utils/interface/truck';
import { IFormTrailer } from '~/utils/interface/trailer';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  CREATE_TRAILER,
  DELETE_TRAILER,
  GET_DETAIL_TRAILER,
  GET_LIST_TRAILER,
  UPDATE_TRAILER,
} from '~/utils/constants/actionType';

export const getListTrailer = createAsyncThunk(
  GET_LIST_TRAILER,
  async (params: IQueryParamTruck, { rejectWithValue }) => {
    try {
      const resp = await trailerApi.getListTrailer(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailTrailer = createAsyncThunk(GET_DETAIL_TRAILER, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await trailerApi.getDetailTrailer(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createTrailer = createAsyncThunk(CREATE_TRAILER, async (body: IFormTrailer, { rejectWithValue }) => {
  try {
    const resp = await trailerApi.createTrailer(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateTrailer = createAsyncThunk(
  UPDATE_TRAILER,
  async (params: IBodyUpdate<IFormTrailer>, { rejectWithValue }) => {
    try {
      const resp = await trailerApi.updateTrailer(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTrailer = createAsyncThunk(DELETE_TRAILER, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await trailerApi.deleteTrailer(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
